export enum EntityListEntities {
  PIPELINE = 'PIPELINE',
  SOURCE = 'SOURCE',
  DESTINATION = 'DESTINATION',
  SOURCE_TYPE = 'SOURCE_TYPE',
  DESTINATION_TYPE = 'DESTINATION_TYPE',
  JOBS_VIEW = 'JOBS_VIEW',
  JOB_OBJECTS = 'JOB_OBJECTS',
  JOB_OBJECT_STAGE_FAILURES = 'JOB_OBJECT_STAGE_FAILURES',
  JOB = 'JOB',
  JOB_DETAILS = 'JobDetails'
}
